import { platformLabel } from "../../ContentGenerator/workflow/platformMeta.jsx";

/** Networks connected through a Meta login: the user must tick every Page they manage. */
export const META_PLATFORMS = ["facebook", "instagram"];

// Query param prefixes bundle.social uses when it sends the user back.
const CALLBACK_PREFIXES = {
  facebook: "facebook",
  instagram: "instagram",
  linkedin: "linkedin",
  tiktok: "tiktok",
  google: "google_business_profile",
  "google-business": "google_business_profile",
};

const CALLBACK_MESSAGES = {
  "instagram-not-professional-account":
    "La cuenta de Instagram no es Profesional o de Creador. Cámbiala en la app de Instagram (Configuración → Tipo de cuenta) y vuelve a conectarla.",
  "instagram-not-enough-accounts":
    "No hemos encontrado ninguna cuenta de Instagram. Si conectas Instagram a través de Facebook, la cuenta tiene que estar vinculada a una Página.",
  "linkedin-not-enough-channels":
    "La cuenta de LinkedIn no administra ninguna página de empresa. Pide acceso de administrador a la página y vuelve a conectarla.",
  "facebook-not-enough-channels":
    "No hemos encontrado ninguna Página de Facebook. La persona que conecta tiene que administrar la Página del cliente.",
};

/** Reads the `*-callback` / error params bundle.social adds on return from its portal. */
export const readPortalReturn = (searchParams) => {
  const results = [];
  searchParams.forEach((value, key) => {
    const prefix = Object.keys(CALLBACK_PREFIXES).find((item) => key.startsWith(`${item}-`));
    if (!prefix) return;
    const platform = CALLBACK_PREFIXES[prefix];
    if (key.endsWith("-callback")) {
      const failed = /error|fail|denied|cancel/i.test(value || "");
      results.push({
        key,
        severity: failed ? "error" : "info",
        message: failed
          ? `No se ha podido conectar ${platformLabel(platform)}. Vuelve a intentarlo.`
          : `Has vuelto de conectar ${platformLabel(platform)}. Comprobamos la conexión...`,
      });
      return;
    }
    results.push({
      key,
      severity: "error",
      message:
        CALLBACK_MESSAGES[key] ||
        `No se ha podido conectar ${platformLabel(platform)} (${key.replace(`${prefix}-`, "").replace(/-/g, " ")}).`,
    });
  });
  return results;
};

// "Volver a Markezy" in the portal returns without callback params, so the pending
// return is remembered here and consumed on the next render of the client.
const PENDING_PORTAL_KEY = "markezy_social_portal_pending";

/** Call right before sending the user to the portal. */
export const markPortalOpened = (clientId) => {
  try {
    sessionStorage.setItem(PENDING_PORTAL_KEY, String(clientId));
  } catch {
    // Storage blocked: the callback params still trigger the sync.
  }
};

/** True (once) when the user comes back from the portal of this client. */
export const consumePortalOpened = (clientId) => {
  try {
    if (sessionStorage.getItem(PENDING_PORTAL_KEY) !== String(clientId)) return false;
    sessionStorage.removeItem(PENDING_PORTAL_KEY);
    return true;
  } catch {
    return false;
  }
};

/** Notice while syncing after a return without callback params. */
export const PORTAL_RETURN_NOTICE = {
  key: "portal-return",
  severity: "info",
  message: "Has vuelto del portal. Comprobamos las conexiones...",
};
